import { logger } from 'shared/infrastructure/logger';

/**
 * Aviso cuando PostHog no arranca, compartido por los `Routes.js` de app y Edelvives. Es `warn` y no `debug`: el
 * arranque incluye código nuestro (`syncPosthogIdentity`) y un fallo ahí tiene que crear issue (TAN-6656).
 */
export function reportPosthogInitFailure(error: unknown): void {
  logger.warn('PostHog init failed', { error });
}
